import React from "react";
import { useSelector } from "react-redux";
import { Button } from "@mui/material";
import { snakeCase } from "lodash";

import { getFontFamily, selectIsJAI, getJaiEditUrl } from "slices";
import { CustomTooltip, Icon } from "components";
import { translation } from "utils";

const BadgeSwitch = ({ disabled, hasEdit = false, jaiEditTitle = "", module = "", setSelectedItem, badgeItems, selectedItem, clearBrowserSelection }) => {
  const fontFamily = useSelector(getFontFamily);
  const isJAI = useSelector(selectIsJAI);
  const jaiEditURL = useSelector(getJaiEditUrl);

  const onBadgeClick = (item) => {
    if (typeof clearBrowserSelection === "function") {
      clearBrowserSelection();
    }

    setSelectedItem(item.id, item);

    const eventHash = {
      event_name: "h_click",
      event_params: {
        h_page_type: "hayley",
        h_clicked_location: module,
        h_stream: "hyly",
        h_display_method: "iframe",
        h_click_value: item.id,
      },
    };

    window.parent.postMessage(JSON.stringify(eventHash), "*");
  };

  if (badgeItems.length < 1) {
    return null;
  }

  return (
    <div className="hayley-flex hayley-w-full hayley-items-start hayley-justify-between">
      <div className="hayley-flex hayley-flex-1 hayley-flex-wrap hayley-items-center">
        {badgeItems.map((item) => (
          <Button
            key={item.id}
            onClick={() => onBadgeClick(item)}
            className={`hayley-custom rounded-sm hayley-mb-2 hayley-mr-[6px] hayley-box-border hayley-border hayley-border-solid hayley-px-[10px] hayley-py-[3px] hayley-text-sm hayley-capitalize hayley-leading-5 hayley-tracking-tight ${
              selectedItem?.id === item.id
                ? "hayley-border-custom-8 hayley-bg-custom-8 hayley-text-white"
                : "hayley-border-custom-7 hayley-bg-custom-7 hayley-text-secondary hover:hayley-border-custom-13 hover:hayley-bg-custom-13"
            } disabled:hayley-cursor-not-allowed`}
            sx={{ "&.hayley-custom": { fontFamily: `${fontFamily} !important` } }}
            disabled={disabled}
            data-testid={snakeCase(`${module}_${item.title}`)}
          >
            {translation(item.id, item.title)}
          </Button>
        ))}
      </div>

      {isJAI && hasEdit && (
        <CustomTooltip title={jaiEditTitle} placement="bottom">
          <div className="hayley-mb-2">
            <a
              href={jaiEditURL}
              target="_blank"
              rel="noreferrer"
              className="hayley-custom hayley-flex hayley-h-4 hayley-min-h-min hayley-w-4 hayley-min-w-min hayley-cursor-pointer hayley-items-center hayley-justify-center hayley-rounded-none hayley-border-none hayley-bg-transparent hayley-p-0 hayley-text-secondary hayley-outline-none hover:hayley-text-primary"
            >
              <Icon iconType="Pencil" className="hayley-h-6 hayley-w-6 hayley-text-inherit" />
            </a>
          </div>
        </CustomTooltip>
      )}
    </div>
  );
};

export default BadgeSwitch;
